import { MessageCircle } from "lucide-react";
import ChatContainer from "../../components/ChatContainer";

const ChatBot = ({ dir, showChat, setShowChat }) => {
  const positionClass = dir === "rtl" ? "left-0" : "right-0";
  const CrossPositionClass = dir === "rtl" ? "left-2" : "right-2";
  const translateClass =
    dir === "rtl"
      ? showChat
        ? "translate-rtl-0"
        : "translate-x-[calc(100%-20rem)]"
      : showChat
        ? "translate-x-0"
        : "-translate-x-[calc(100%-20rem)]";

  return (
    <div
      className={`fixed ${!showChat ? "z-10" : "z-10"} top-0 ${positionClass} h-full flex transform transition-transform duration-300 ${translateClass}`}
    >
      {/* Floating Button */}
      {showChat && (
        <button
          onClick={() => setShowChat(!showChat)}
          className="flex items-center justify-center bg-[#B03982] text-white w-14 h-14 rounded-full shadow-lg mt-auto mb-auto"
        >
          <MessageCircle size={28} />
        </button>
      )}

      <button
        onClick={() => setShowChat(!showChat)}
      >
        <span className={`absolute top-2 z-[10] ${CrossPositionClass} text-gray-500 cursor-pointer text-xl font-bold`}>✕</span>
      </button>

      {/* Chat Panel */}
      <div className="w-80 bg-white shadow-lg border-l flex flex-col">
        {/* Conversation area */}
        <div className="p-5 flex-1 overflow-y-auto space-y-4">
          <ChatContainer dir={dir} />
        </div>
      </div>
    </div>
  );
};

export default ChatBot;
